import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { RequirePermission } from "@/libs/guard/admin-permission-guard";

// Journal
const JournalPage = lazy(() => import("@/shared/journal/pages"));
const JournalDetailsPage = lazy(
  () => import("@/shared/journal/pages/journal-details")
);

export const journalRoutes: RouteObject[] = [
  {
    path: "/admin/view-student-journal/:studentId",
    element: (
      <RequirePermission resource="student-journal">
        <JournalPage isAdmin={true} />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/view-journal-details/:studentId/:journalId",
    element: (
      <RequirePermission resource="student-journal">
        <JournalDetailsPage />
      </RequirePermission>
    ),
  },
];
